// eslint-disable-next-line import/no-cycle
import ProductComparisonTable from "./components/ProductComparisonTable"
import { transformProductForCompare } from "./helperFunctions"
import useStyles from "./styles"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { useUrlQuery } from "../../lib/hooks/urlQueryHooks"
import { strings as Localization } from "../../lib/Localization"
import { addToCompare, setIsOnComparePage } from "../../redux/compareProductsReducer"
import { useCompareProducts } from "../../redux/hook/compareHooks"
import { useFilteredProducts } from "../../redux/hook/productHooks"
import { productViewBreakpoint } from "../../lib/helper/viewportHelper"
import theme from "../../theme"
import { batch, useDispatch } from "react-redux"
import React, { useEffect, useMemo } from "react"
import { Box, Typography, useMediaQuery } from "@material-ui/core"

const CompareProducts = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const isMobile = useMediaQuery(theme.breakpoints.down(productViewBreakpoint))
    const language = useLanguage()
    const queryParams = useUrlQuery()
    const productForCompareIds = useCompareProducts()

    const filter = useMemo(
        () => ({ productIds: productForCompareIds ?? [] }),
        [productForCompareIds]
    )
    let products = useFilteredProducts(filter)
    products = products.map(p => transformProductForCompare(p))

    const getCompareUrl = () => {
        const cleanedUrl = window.location.toString().replace(window.location.search, "")
        const url = new URL(cleanedUrl)
        if (productForCompareIds && productForCompareIds.length > 0) {
            url.searchParams.set("id", productForCompareIds)
            url.searchParams.sort()
        }
        return url
    }

    const setCompareUrl = () => {
        const url = getCompareUrl()
        window.history.pushState({}, "", url)
    }

    useEffect(() => {
        const ids = (queryParams.get("id") ?? "")
            .split(",")
            .filter(id => Boolean(id))

        batch(() => {
            ids.forEach(id => {
                dispatch(addToCompare(id))
            })
            dispatch(setIsOnComparePage(true))
        })

        return () => {
            dispatch(setIsOnComparePage(false))
        }
    }, [])

    useEffect(() => {
        setCompareUrl()
    }, [productForCompareIds, language])

    return (
        <Box className={classes.content} style={{ padding: isMobile && 0 }}>
            <Typography variant="h3" className={classes.capitalized} gutterBottom>{Localization.compareProducts}</Typography>
            {
                products.length > 0
                    ? (
                        <Box className={classes.result} style={{ padding: isMobile && 0 }}>
                            <ProductComparisonTable products={products} />
                        </Box>
                    )
                    : (
                        <Box>
                            <Typography>{Localization.noProductsToCompare}</Typography>
                        </Box>
                    )
            }
        </Box>
    )
}

export default CompareProducts
